import * as types from './actionTypes';

// fetch Relations
export function fetchRelations({ idSalesRoute }) {
  return {
    type: types.FETCH_RELATIONS_REQUEST,
    idSalesRoute,
  };
}
export function fetchRelationsSuccess({ data }) {
  return {
    type: types.FETCH_RELATIONS_SUCCESS,
    data,
  };
}
export function fetchRelationsFail({ error }) {
  return {
    type: types.FETCH_RELATIONS_FAIL,
    error,
  };
}

// fetch Questionnaires
export function fetchQuestionnaires({ idSalesRoute }) {
  return {
    type: types.FETCH_QUESTIONNAIRES_REQUEST,
    idSalesRoute,
  };
}
export function fetchQuestionnairesSuccess({ idSalesRoute, data }) {
  return {
    type: types.FETCH_QUESTIONNAIRES_SUCCESS,
    idSalesRoute,
    data,
  };
}
export function fetchQuestionnairesFail({ error }) {
  return {
    type: types.FETCH_QUESTIONNAIRES_FAIL,
    error,
  };
}

// fetch Questionnaire by Id
export function fetchQuestionnaire({ id }) {
  return {
    type: types.FETCH_QUESTIONNAIRE_REQUEST,
    id,
  };
}
export function fetchQuestionnaireSuccess({ data, id }) {
  return {
    type: types.FETCH_QUESTIONNAIRE_SUCCESS,
    data,
    id,
  };
}
export function fetchQuestionnaireFail({ error, id }) {
  return {
    type: types.FETCH_QUESTIONNAIRE_FAIL,
    error,
    id,
  };
}

// fetch Product Descriptions
export function fetchProductDescriptions({ idSalesRoute }) {
  return {
    type: types.FETCH_PRODUCT_DESCRIPTIONS_REQUEST,
    idSalesRoute,
  };
}
export function fetchProductDescriptionsSuccess({ idSalesRoute, data }) {
  return {
    type: types.FETCH_PRODUCT_DESCRIPTIONS_SUCCESS,
    idSalesRoute,
    data,
  };
}
export function fetchProductDescriptionsFail({ error }) {
  return {
    type: types.FETCH_PRODUCT_DESCRIPTIONS_FAIL,
    error,
  };
}

// fetch Product Description by Id
export function fetchProductDescription({ id }) {
  return {
    type: types.FETCH_PRODUCT_DESCRIPTION_REQUEST,
    id,
  };
}
export function fetchProductDescriptionSuccess({ data, id }) {
  return {
    type: types.FETCH_PRODUCT_DESCRIPTION_SUCCESS,
    data,
    id,
  };
}
export function fetchProductDescriptionFail({ error, id }) {
  return {
    type: types.FETCH_PRODUCT_DESCRIPTION_FAIL,
    error,
    id,
  };
}

// fetch SalesRoute
export function fetchSalesRoute({ id }) {
  return {
    type: types.FETCH_SALESROUTE_REQUEST,
    id,
  };
}
export function fetchSalesRouteSuccess({ data, id }) {
  return {
    type: types.FETCH_SALESROUTE_SUCCESS,
    data,
    id,
  };
}
export function fetchSalesRouteFail({ error, id }) {
  return {
    type: types.FETCH_SALESROUTE_FAIL,
    error,
    id,
  };
}

// fetch SalesRoutes
export function fetchSalesRoutes() {
  return {
    type: types.FETCH_SALESROUTES_REQUEST,
  };
}
export function fetchSalesRoutesSuccess({ data, id }) {
  return {
    type: types.FETCH_SALESROUTES_SUCCESS,
    data,
    id,
  };
}
export function fetchSalesRoutesFail({ error, id }) {
  return {
    type: types.FETCH_SALESROUTES_FAIL,
    error,
    id,
  };
}

// Create SalesRoute
export function createSalesRoute({ payload, history }) {
  return {
    type: types.CREATE_SALESROUTE_REQUEST,
    payload,
    history,
  };
}
export function createSalesRouteSuccess({ data, id }) {
  return {
    type: types.CREATE_SALESROUTE_SUCCESS,
    data,
    id,
  };
}
export function createSalesRouteFail({ error, id }) {
  return {
    type: types.CREATE_SALESROUTE_FAIL,
    error,
    id,
  };
}

// Update SalesRoute
export function updateSalesRoute({ payload, id }) {
  return {
    type: types.UPDATE_SALESROUTE_REQUEST,
    payload,
    id,
  };
}
export function updateSalesRouteSuccess({ data, id }) {
  return {
    type: types.UPDATE_SALESROUTE_SUCCESS,
    data,
    id,
  };
}
export function updateSalesRouteFail({ error, id }) {
  return {
    type: types.UPDATE_SALESROUTE_FAIL,
    error,
    id,
  };
}

// Patch SalesRoute
export function patchSalesRoute({ payload, id }) {
  return {
    type: types.PATCH_SALESROUTE_REQUEST,
    payload,
    id,
  };
}
export function patchSalesRouteSuccess({ data, id }) {
  return {
    type: types.PATCH_SALESROUTE_SUCCESS,
    data,
    id,
  };
}
export function patchSalesRouteFail({ error, id }) {
  return {
    type: types.PATCH_SALESROUTE_FAIL,
    error,
    id,
  };
}

/**
 * Reset form SalesRoute
 */
export function resetFormSalesRoute() {
  return {
    type: types.RESET_FORM_SALESROUTE_REQUEST,
  };
}
export function resetFormSalesRouteSuccess() {
  return {
    type: types.RESET_FORM_SALESROUTE_SUCCESS,
  };
}

/**
 *  Partial Update SalesRoute
 */
// Answers
export function partialUpdateSalesRouteAnswers(payload, id) {
  return {
    type: types.PARTIAL_UPDATE_SALESROUTE_ANSWERS_REQUEST,
    payload,
    id,
  };
}
export function partialUpdateSalesRouteAnswersSuccess({ data, id }) {
  return {
    type: types.PARTIAL_UPDATE_SALESROUTE_ANSWERS_SUCCESS,
    data,
    id,
  };
}
export function partialUpdateSalesRouteAnswersFail({ error, id }) {
  return {
    type: types.PARTIAL_UPDATE_SALESROUTE_ANSWERS_FAIL,
    error,
    id,
  };
}
// Loans
export function partialUpdateSalesRouteLoans(payload, id) {
  return {
    type: types.PARTIAL_UPDATE_SALESROUTE_LOANS_REQUEST,
    payload,
    id,
  };
}
export function partialUpdateSalesRouteLoansSuccess({ data, id }) {
  return {
    type: types.PARTIAL_UPDATE_SALESROUTE_LOANS_SUCCESS,
    data,
    id,
  };
}
export function partialUpdateSalesRouteLoansFail({ error, id }) {
  return {
    type: types.PARTIAL_UPDATE_SALESROUTE_LOANS_FAIL,
    error,
    id,
  };
}
// Quotations
export function partialUpdateSalesRouteQuotations(payload, id) {
  return {
    type: types.PARTIAL_UPDATE_SALESROUTE_QUOTATIONS_REQUEST,
    payload,
    id,
  };
}
export function partialUpdateSalesRouteQuotationsSuccess({ data, id }) {
  return {
    type: types.PARTIAL_UPDATE_SALESROUTE_QUOTATIONS_SUCCESS,
    data,
    id,
  };
}
export function partialUpdateSalesRouteQuotationsFail({ error, id }) {
  return {
    type: types.PARTIAL_UPDATE_SALESROUTE_QUOTATIONS_FAIL,
    error,
    id,
  };
}
// ExtraData Contract
export function partialUpdateSalesRouteExtraData(payload, id) {
  return {
    type: types.PARTIAL_UPDATE_SALESROUTE_EXTRADATA_REQUEST,
    payload,
    id,
  };
}
export function partialUpdateSalesRouteExtraDataSuccess({ data, id }) {
  return {
    type: types.PARTIAL_UPDATE_SALESROUTE_EXTRADATA_SUCCESS,
    data,
    id,
  };
}
export function partialUpdateSalesRouteExtraDataFail({ error, id }) {
  return {
    type: types.PARTIAL_UPDATE_SALESROUTE_EXTRADATA_FAIL,
    error,
    id,
  };
}
// GeneralData Contract
export function partialUpdateSalesRouteGeneralData(payload, id) {
  return {
    type: types.PARTIAL_UPDATE_SALESROUTE_GENERALDATA_REQUEST,
    payload,
    id,
  };
}
export function partialUpdateSalesRouteGeneralDataSuccess({ data, id }) {
  return {
    type: types.PARTIAL_UPDATE_SALESROUTE_GENERALDATA_SUCCESS,
    data,
    id,
  };
}
export function partialUpdateSalesRouteGeneralDataFail({ error, id }) {
  return {
    type: types.PARTIAL_UPDATE_SALESROUTE_GENERALDATA_FAIL,
    error,
    id,
  };
}
// Contract (Offers)
export function partialUpdateSalesRouteContract(payload, id) {
  return {
    type: types.PARTIAL_UPDATE_SALESROUTE_CONTRACT_REQUEST,
    payload,
    id,
  };
}
export function partialUpdateSalesRouteContractSuccess({ data, id }) {
  return {
    type: types.PARTIAL_UPDATE_SALESROUTE_CONTRACT_SUCCESS,
    data,
    id,
  };
}
export function partialUpdateSalesRouteContractFail({ error, id }) {
  return {
    type: types.PARTIAL_UPDATE_SALESROUTE_CONTRACT_FAIL,
    error,
    id,
  };
}
// Contract then print (Offers)
export function partialUpdateSalesRouteContractPrint(payload, id) {
  return {
    type: types.PARTIAL_UPDATE_SALESROUTE_CONTRACT_PRINT_REQUEST,
    payload,
    id,
  };
}
export function partialUpdateSalesRouteContractPrintSuccess({ data, id }) {
  return {
    type: types.PARTIAL_UPDATE_SALESROUTE_CONTRACT_PRINT_SUCCESS,
    data,
    id,
  };
}
export function partialUpdateSalesRouteContractPrintFail({ error, id }) {
  return {
    type: types.PARTIAL_UPDATE_SALESROUTE_CONTRACT_PRINT_FAIL,
    error,
    id,
  };
}
// Subscription
export function partialUpdateSalesRouteSubscription(payload, id) {
  return {
    type: types.PARTIAL_UPDATE_SALESROUTE_SUBSCRIPTION_REQUEST,
    payload,
    id,
  };
}
export function partialUpdateSalesRouteSubscriptionSuccess({ data, id }) {
  return {
    type: types.PARTIAL_UPDATE_SALESROUTE_SUBSCRIPTION_SUCCESS,
    data,
    id,
  };
}
export function partialUpdateSalesRouteSubscriptionFail({ error, id }) {
  return {
    type: types.PARTIAL_UPDATE_SALESROUTE_SUBSCRIPTION_FAIL,
    error,
    id,
  };
}

/**
 * Simulate Quotations
 */

export function simulateQuotations(id) {
  return {
    type: types.SIMULATE_QUOTATIONS_REQUEST,
    id,
  };
}
export function simulateQuotationsSuccess({ data, id }) {
  return {
    type: types.SIMULATE_QUOTATIONS_SUCCESS,
    data,
    id,
  };
}
export function simulateQuotationsFail({ error, id }) {
  return {
    type: types.SIMULATE_QUOTATIONS_FAIL,
    error,
    id,
  };
}

/**
 * Subscribe Contracts
 */

export function subscribeContracts({ id }) {
  return {
    type: types.SUBSCRIBE_CONTRACTS_REQUEST,
    id,
  };
}
export function subscribeContractsSuccess({ data, id }) {
  return {
    type: types.SUBSCRIBE_CONTRACTS_SUCCESS,
    data,
    id,
  };
}
export function subscribeContractsFail({ error, id }) {
  return {
    type: types.SUBSCRIBE_CONTRACTS_FAIL,
    error,
    id,
  };
}

/**
 * Compute Questionnaires Action
 */
export function computeQuestionnaire(id) {
  return {
    type: types.COMPUTE_QUESTIONNAIRES_REQUEST,
    id,
  };
}
export function computeQuestionnaireSuccess({ data, id }) {
  return {
    type: types.COMPUTE_QUESTIONNAIRES_SUCCESS,
    data,
    id,
  };
}
export function computeQuestionnaireFail({ error, id }) {
  return {
    type: types.COMPUTE_QUESTIONNAIRES_FAIL,
    error,
    id,
  };
}

/**
 * Fetch Quotation Descriptions
 */
export function fetchQuotationDescriptions(id) {
  return {
    type: types.FETCH_QUOTATION_DESCRIPTIONS_REQUEST,
    id,
  };
}
export function fetchQuotationDescriptionsSuccess({ data, id }) {
  return {
    type: types.FETCH_QUOTATION_DESCRIPTIONS_SUCCESS,
    data,
    id,
  };
}
export function fetchQuotationDescriptionsFail({ error, id }) {
  return {
    type: types.FETCH_QUOTATION_DESCRIPTIONS_FAIL,
    error,
    id,
  };
}

// Calculate Offers Action
export function calculateOffers({ data, id }) {
  return {
    type: types.CALCULATE_OFFERS_REQUEST,
    data,
    id,
  };
}
export function calculateOffersSuccess({ data, id }) {
  return {
    type: types.CALCULATE_OFFERS_SUCCESS,
    data,
    id,
  };
}
export function calculateOffersFail({ error, id }) {
  return {
    type: types.CALCULATE_OFFERS_FAIL,
    error,
    id,
  };
}

/**
 * put on hold a SalesRoute by ID
 */
export function putOnHoldSalesRoute({ id, payload }) {
  return {
    type: types.PUTONHOLD_SALESROUTE_REQUEST,
    id,
    payload,
  };
}
export function putOnHoldSalesRouteSuccess({ data, id }) {
  return {
    type: types.PUTONHOLD_SALESROUTE_SUCCESS,
    data,
    id,
  };
}
export function putOnHoldSalesRouteFail({ error, id }) {
  return {
    type: types.PUTONHOLD_SALESROUTE_FAIL,
    error,
    id,
  };
}

/**
 * cancel a SalesRoute by ID
 */
export function cancelSalesRoute(id) {
  return {
    type: types.CANCEL_SALESROUTE_REQUEST,
    id,
  };
}
export function cancelSalesRouteSuccess({ data, id }) {
  return {
    type: types.CANCEL_SALESROUTE_SUCCESS,
    data,
    id,
  };
}
export function cancelSalesRouteFail({ error, id }) {
  return {
    type: types.CANCEL_SALESROUTE_FAIL,
    error,
    id,
  };
}

/**
 * Print Salesroute
 */
export function printSalesRoute({ id }) {
  return {
    type: types.PRINT_SALESROUTE_REQUEST,
    id,
  };
}
export function printSalesRouteSuccess({ data, id }) {
  return {
    type: types.PRINT_SALESROUTE_SUCCESS,
    data,
    id,
  };
}
export function printSalesRouteFail({ error, id }) {
  return {
    type: types.PRINT_SALESROUTE_FAIL,
    error,
    id,
  };
}

/**
 * Synchronize Salesroute
 */
export function synchronizeSalesRouteWithSalesForce(id) {
  return {
    type: types.SYNCHRONIZE_SALESROUTE_REQUEST,
    id,
  };
}
export function synchronizeSalesRouteWithSalesForceSuccess({ data, id, closeWindow = false }) {
  return {
    type: types.SYNCHRONIZE_SALESROUTE_SUCCESS,
    data,
    id,
    closeWindow,
  };
}
export function synchronizeSalesRouteWithSalesForceFail({ error, id }) {
  return {
    type: types.SYNCHRONIZE_SALESROUTE_FAIL,
    error,
    id,
  };
}
/**
 * Extend Salesroutes
 */
export function extendSalesroutes() {
  return {
    type: types.EXTEND_SALESROUTES_REQUEST,
  };
}
export function extendSalesroutesSuccess({ data }) {
  return {
    type: types.EXTEND_SALESROUTES_SUCCESS,
    data,
  };
}
export function extendSalesroutesFail({ error }) {
  return {
    type: types.EXTEND_SALESROUTES_FAIL,
    error,
  };
}

/**
 * Can't update SalesRoute
 */
export function noUpdateSalesRoute({ error }) {
  return {
    type: types.NO_UPDATE_SALESROUTE,
    error,
  };
}

/**
 * Change person type for subscription
 */
export function changePersonType({ id, value }) {
  return {
    type: types.CHANGE_PERSON_TYPE,
    id,
    value,
  };
}

/**
 * QuotationBlock Change Data Schema
 */
// TODO not remove , gross_salary POC
export function quotationBlockChangeField({ code, answers }) {
  return {
    type: types.QUOTATIONBLOCK_CHANGE_FIELD_REQUEST,
    code,
    answers,
  };
}
export function quotationBlockChangeFieldSuccess({ code, value }) {
  return {
    type: types.QUOTATIONBLOCK_CHANGE_FIELD_SUCCESS,
    code,
    value,
  };
}
export function quotationBlockChangeFieldFail({ error }) {
  return {
    type: types.QUOTATIONBLOCK_CHANGE_FIELD_FAIL,
    error,
  };
}
